import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { TranslocoModule } from '@ngneat/transloco';

import { InvalidFeedbackComponent } from './components/invalid-feedback/invalid-feedback.component';
import { BackButtonDirective } from './directives/back-button.directive';
import { SelectOnFocusDirective } from './directives/select-on-focus.directive';
import { DurationToStringPipe } from './pipes/duration-to-string.pipe';
import { MsToTimePipe } from './pipes/ms-to-time.pipe';
import { SafePipe } from './pipes/safe.pipe';
import { UtcToLocal } from './pipes/utc-to-local.pipe';

@NgModule({
  imports: [
    CommonModule,
    TranslocoModule
  ],
  declarations: [
    InvalidFeedbackComponent,
    SelectOnFocusDirective,
    SafePipe,
    UtcToLocal,
    MsToTimePipe,
    DurationToStringPipe,
    BackButtonDirective
  ],
  exports: [
    InvalidFeedbackComponent,
    SelectOnFocusDirective,
    SafePipe,
    UtcToLocal,
    MsToTimePipe,
    DurationToStringPipe,
    BackButtonDirective
  ]
})
export class MiscModule { }
